(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("67vMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0126634dfaac58f4$export$6503ec6e8aabbaf; }, function (v) { return $0126634dfaac58f4$export$6503ec6e8aabbaf = v; });
var $0126634dfaac58f4$export$6503ec6e8aabbaf;
var $0126634dfaac58f4$export$f7ad0328861e2f03;
"use strict";
var $0126634dfaac58f4$var$mapping = new Map();
function $0126634dfaac58f4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0126634dfaac58f4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0126634dfaac58f4$var$resolve(id) {
    var resolved = $0126634dfaac58f4$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0126634dfaac58f4$export$6503ec6e8aabbaf = $0126634dfaac58f4$var$register;
$0126634dfaac58f4$export$f7ad0328861e2f03 = $0126634dfaac58f4$var$resolve;

});

parcelRegister("91XAa", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $69326cdf618f5df6$export$bdfd709ae4826697; }, function (v) { return $69326cdf618f5df6$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $69326cdf618f5df6$export$5a759dc7a1cfb72a; }, function (v) { return $69326cdf618f5df6$export$5a759dc7a1cfb72a = v; });
var $69326cdf618f5df6$export$bdfd709ae4826697;
var $69326cdf618f5df6$export$c9e73fbda7da57b6;
var $69326cdf618f5df6$export$5a759dc7a1cfb72a;
"use strict";
var $69326cdf618f5df6$var$bundleURL = {};
function $69326cdf618f5df6$var$getBundleURLCached(id) {
    var value = $69326cdf618f5df6$var$bundleURL[id];
    if (!value) {
        value = $69326cdf618f5df6$var$getBundleURL();
        $69326cdf618f5df6$var$bundleURL[id] = value;
    }
    return value;
}
function $69326cdf618f5df6$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $69326cdf618f5df6$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $69326cdf618f5df6$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $69326cdf618f5df6$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$69326cdf618f5df6$export$bdfd709ae4826697 = $69326cdf618f5df6$var$getBundleURLCached;
$69326cdf618f5df6$export$c9e73fbda7da57b6 = $69326cdf618f5df6$var$getBaseURL;
$69326cdf618f5df6$export$5a759dc7a1cfb72a = $69326cdf618f5df6$var$getOrigin;

});

var $e942fe1cbc2032d8$exports = {};


(parcelRequire("67vMA")).register((parcelRequire("91XAa")).getBundleURL('glOsZ'), JSON.parse("[\"glOsZ\",\"index.91c9fb79.js\",\"dPT7b\",\"worker.faf85ebd.js\"]"));

/** @typedef {import("./worker.js").Desc} Desc */ /** @typedef {import("./worker.js").WRequest} WRequest */ /** @typedef {import("./worker.js").WResponse} WResponse */ /** @typedef {import("./worker.js").WorkerRequest} WorkerRequest */ /** @typedef {import("./worker.js").WorkerResponse} WorkerResponse */ var $e005ed87d6ee3bc1$exports = {};
var $e977dcd22b23f9a6$exports = {};
"use strict";
$e977dcd22b23f9a6$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};



var $91XAa = parcelRequire("91XAa");
let $e005ed87d6ee3bc1$var$url = $91XAa.getBundleURL('glOsZ') + "worker.faf85ebd.js";
$e005ed87d6ee3bc1$exports = $e977dcd22b23f9a6$exports($e005ed87d6ee3bc1$var$url, $91XAa.getOrigin($e005ed87d6ee3bc1$var$url), false);


document.addEventListener('DOMContentLoaded', ()=>{
    const form = /** @type {HTMLFormElement} */ document.getElementById('search_form');
    const input = /** @type {HTMLInputElement} */ document.getElementById('search_query');
    const resultDiv = /** @type {HTMLDivElement} */ document.getElementById('result');
    /** @param {string} queryStr */ function parseQuery(queryStr) {
        /** @type {string[]} */ const query = [];
        for(let tokenRe = /([a-z][a-z0-9_-]{4,})|&CDP-([\dA-F]{4});|&_BS-UC-(\d{4});|U\+([\dA-F]{1,6})|&#[Xx]([\da-fA-F]+);|&#(\d+);|(\S)/gu, m; (m = tokenRe.exec(queryStr)) !== null;){
            const [, glyphName, cdp, bsuc, codepoint0, hexCode, decCode, singleChar] = m;
            if (glyphName) {
                query.push(glyphName);
                continue;
            }
            if (cdp) {
                query.push(`abst:cdp-${cdp.toLowerCase()}`);
                continue;
            }
            if (bsuc) {
                query.push(`abst:_bs-uc-${bsuc}`);
                continue;
            }
            /** @type {number} */ let codepoint;
            if (codepoint0) codepoint = parseInt(codepoint0, 16);
            else if (hexCode) codepoint = parseInt(hexCode, 16);
            else if (decCode) codepoint = parseInt(decCode, 10);
            else codepoint = singleChar.codePointAt(0);
            query.push(`abst:u${codepoint.toString(16).padStart(4, '0')}`);
        }
        return query;
    }
    const worker = new Worker($e005ed87d6ee3bc1$exports);
    /** @type {{ resolve: (dat: WResponse) => void; reject: (err: any) => void; }[]} */ const promises = [];
    worker.addEventListener('message', (evt)=>{
        if (!(evt.data instanceof Object)) return;
        const res = /** @type {WorkerResponse} */ evt.data;
        const promise = promises[res.id];
        if (!promise) return;
        if ("error" in res) {
            promise.reject(res.error);
            return;
        }
        promise.resolve(res);
    });
    /**
   * @param {WRequest} req
   * @returns {Promise<WResponse>}
   */ function requestWorker(req) {
        return new Promise((resolve, reject)=>{
            const id = promises.push({
                resolve: resolve,
                reject: reject
            }) - 1;
            worker.postMessage(/** @type {WorkerRequest} */ {
                ...req,
                id: id
            });
        });
    }
    /**
   * @param {string[]} query
   * @returns {Promise<Desc[]>}
   */ async function processQuery(query) {
        const res = await requestWorker({
            type: "query",
            query: query
        });
        return /** @type {import('./worker.js').ProcessQueryResponse} */ res.value;
    }
    /**
   * @param {string[]} items
   * @returns {Promise<Desc[]>}
   */ async function getChildren(items) {
        const res = await requestWorker({
            type: "children",
            items: items
        });
        return /** @type {import('./worker.js').ChildrenResponse} */ res.value;
    }
    /** @type {string[] | null} */ let currentQuery = null;
    /** @param {string} queryStr */ function doSearch(queryStr) {
        const query = parseQuery(queryStr);
        currentQuery = query;
        processQuery(query).then((result)=>{
            if (currentQuery !== query) return;
            showResult(result);
        }).catch((err)=>{
            console.error(err);
        });
    }
    form.addEventListener('submit', (evt)=>{
        evt.preventDefault();
        while(resultDiv.firstChild)resultDiv.removeChild(resultDiv.firstChild);
        resultDiv.appendChild(document.createTextNode("(\u691C\u7D22\u4E2D)"));
        const query = input.value;
        doSearch(query);
    });
    /** @param {Desc[]} result */ function showResult(result) {
        while(resultDiv.firstChild)resultDiv.removeChild(resultDiv.firstChild);
        if (!result.length) {
            resultDiv.appendChild(document.createTextNode("(\u8A72\u5F53\u7D50\u679C\u306A\u3057)"));
            return;
        }
        const resultUl = generateUl(result);
        resultDiv.appendChild(resultUl);
    }
    /** @param {Desc[]} descs */ function generateUl(descs) {
        const ul = document.createElement('ul');
        for (const { names: names, children: children } of descs){
            const li = document.createElement('li');
            if (children.length) {
                li.dataset.children = children.map((child)=>child[0]).join(',');
                const btn = document.createElement('button');
                btn.appendChild(document.createTextNode('+'));
                li.appendChild(btn);
            }
            for (const [index, name] of names.entries()){
                if (index !== 0) li.appendChild(document.createTextNode(' = '));
                const node = generateRepresentationNode(name, index !== 0);
                li.appendChild(node);
            }
            ul.appendChild(li);
        }
        return ul;
    }
    /**
   * @param {string} name 
   * @param {boolean=} simpler
   */ function generateRepresentationNode(name, simpler) {
        if (name.startsWith('abst:')) {
            let text = name.substring(5);
            if (/^abst:cdp-[0-9a-f]{4}$/.test(name)) text = `&CDP-${name.substring(9).toUpperCase()};`;
            else if (/^abst:u[0-9a-f]{4,}$/.test(name)) {
                const codepointHex = name.substring(6);
                const char = String.fromCodePoint(parseInt(codepointHex, 16));
                text = `U+${codepointHex.toUpperCase()}: ${char}`;
            } else if (/^abst:_bs-uc-\d{4}$/.test(name)) text = `&_BS-UC-${name.substring(12)};`;
            return document.createTextNode(text);
        }
        const link = document.createElement('a');
        link.href = `https://glyphwiki.org/wiki/${name}`;
        link.title = name;
        if (!simpler) {
            const img = document.createElement('img');
            img.loading = 'lazy';
            img.src = `https://glyphwiki.org/glyph/${name}.50px.png`;
            img.alt = img.title = name;
            img.className = 'thumb';
            link.appendChild(img);
        }
        link.appendChild(document.createTextNode(name));
        return link;
    }
    resultDiv.addEventListener('click', (evt)=>{
        if (!(evt.target instanceof HTMLButtonElement && evt.target.parentNode instanceof HTMLLIElement && evt.target.parentNode.dataset.children)) return;
        const btn = evt.target;
        const li = evt.target.parentNode;
        if (li.lastChild instanceof HTMLUListElement) {
            btn.textContent = '+';
            li.removeChild(li.lastChild);
            return;
        }
        btn.disabled = true;
        const items = li.dataset.children.split(',');
        getChildren(items).then((children)=>{
            if (!resultDiv.contains(li)) return;
            const ul = generateUl(children);
            btn.disabled = false;
            btn.textContent = '-';
            li.appendChild(ul);
        });
    });
});

})();
//# sourceMappingURL=index.91c9fb79.js.map
